export const getAncestorPlaceTypeName = (type, place = {}, multiple = false) => {
  /**
   * For a given place, traverse its ancestry (if necessary) to determine
   * the name of the location of type "type" (of equal or lesser specificity)
   * that it belongs to.
   * ie, retrieve "United States" from the place object for Nashville.
   */
  // TODO: add tests
  const { ancestry, placeType, name: placeName } = place;

  if (placeType === type) {
    return multiple ? [placeName] : placeName;
  }

  if (Array.isArray(ancestry)) {
    const relevantAncestors = ancestry.filter(
      ({ type: ancestorResourceType, placeType: ancestorPlaceType }) =>
        ancestorResourceType === "place" && ancestorPlaceType === type,
    );
    if (relevantAncestors.length > 0) {
      return multiple ? relevantAncestors.map(({ name }) => name) : relevantAncestors[0].name;
    }
  }

  return undefined;
};



// WEBPACK FOOTER //
// ./assets/shared/utils/getAncestorPlaceTypeName.js